import { createReducer, on } from '@ngrx/store';
import * as SearchActions from '../actions/hearings-search.actions';
import { SearchResult } from 'src/app/services/NewSearchDataWebService';

// Constant for the feature state key
export const HEARING_SEARCH_FEATURE_KEY = 'hearingSearch';

export interface SearchState {
  responses: { [key: string]: SearchResult | null };
  errors: { [key: string]: any | null };
  loading: { [key: string]: boolean };
}

export const initialState: SearchState = {
  responses: {},
  errors: {},
  loading: {},
};

export const searchReducer = createReducer(
  initialState,
  on(SearchActions.clearSearchResults, () => initialState),
  on(SearchActions.searchHearings, (state, { context }) => ({
    ...state,
    loading: { ...state.loading, [context]: true },
    errors: { ...state.errors, [context]: null },
  })),
  on(SearchActions.searchHearingsSuccess, (state, { response, context }) => ({
    ...state,
    responses: { ...state.responses, [context]: response },
    loading: { ...state.loading, [context]: false }
  })),
  on(SearchActions.searchHearingsFailure, (state, { error, context }) => ({
    ...state,
    errors: { ...state.errors, [context]: error },
    loading: { ...state.loading, [context]: false }
  }))
);

